export default "__VITE_ASSET__65676b5b__"